export const DATA_TABLE_CATEGORY = [
    { value: 'S', label: 'System Table' },
    { value: 'D', label: 'Dimension Table' },
    { value: 'F', label: 'Fact Table' },
    { value: 'H', label: 'Help Table' },
    { value: 'R', label: 'Result Table' },
    { value: 'Dictionary', label: 'Dictionary' },
];
